// ============================================================================
// USER MANAGEMENT ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/lmms/v1/user-access';

export const userManagementEndpoints = {
  list: () => buildEndpoint(`${BASE_PATH}/users-lookup`),
  resetPassword: (userId: ID) => buildEndpointWithParams(`${BASE_PATH}/:userId/reset-password`, { userId }),
} as const;

export default userManagementEndpoints;
